<!-- dashboard-layout.component.html -->
<div class="fo-layout">

  <!-- ══════════════════════════════
       SIDEBAR OVERLAY (mobile)
  ══════════════════════════════ -->
  <div class="fo-sidebar-overlay" [class.is-visible]="!sidebarCollapsed" (click)="closeSidebar()">
  </div>

  <!-- ══════════════════════════════
       SIDEBAR
  ══════════════════════════════ -->
  <aside class="fo-sidebar" [class.is-collapsed]="sidebarCollapsed">

    <!-- Brand -->
    <div class="fo-sb-brand">
      <div class="fo-sb-logo">
        <img src="assets/images/fieldlogo.png" alt="FieldOps"
          onerror="this.style.display='none'; this.nextElementSibling.style.display='block'">
        <span style="display:none">FO</span>
      </div>
      <span class="fo-sb-brand-name">KinexOps</span>
      <button class="fo-sb-toggle" (click)="toggleSidebar()" aria-label="Toggle sidebar">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>

    <!-- Nav links -->
    <nav class="fo-sb-nav">

      <!-- ── MAIN ─────────────────────────────────────── -->
      <div class="fo-sb-section">MAIN</div>

      <a routerLink="/dashboard" routerLinkActive="fo-active" class="fo-sb-link" (click)="onNavClick()">
        <span class="fo-sb-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.8" />
            <rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.8" />
            <rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.8" />
            <rect x="14" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.8" />
          </svg>
        </span>
        <span class="fo-sb-link-label">Dashboard</span>
      </a>

      <!-- Live Map — Starter and above -->
      <a routerLink="/live-map" routerLinkActive="fo-active" class="fo-sb-link"
        [class.fo-sb-link--locked]="!canAccessLiveMap" (click)="onNavClick()"
        [title]="canAccessLiveMap ? 'Live Map' : 'Upgrade to access Live Map'">
        <span class="fo-sb-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M12 2C8.1 2 5 5.1 5 9C5 14.2 12 22 12 22C12 22 19 14.2 19 9C19 5.1 15.9 2 12 2Z"
              stroke="currentColor" stroke-width="1.8" />
            <circle cx="12" cy="9" r="2.5" stroke="currentColor" stroke-width="1.8" />
          </svg>
        </span>
        <span class="fo-sb-link-label">Live Map</span>
        <span class="fo-sb-live-dot" *ngIf="canAccessLiveMap"></span>
        <span class="fo-sb-lock-icon" *ngIf="!canAccessLiveMap">🔒</span>
      </a>

      <!-- ── WORKERS ──────────────────────────────────── -->
      <div class="fo-sb-section">WORKERS</div>

      <a routerLink="/workers" routerLinkActive="fo-active" class="fo-sb-link" (click)="onNavClick()">
        <span class="fo-sb-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.8" />
            <path d="M2 20C2 17 5 14 9 14C13 14 16 17 16 20" stroke="currentColor" stroke-width="1.8"
              stroke-linecap="round" />
            <path d="M19 8V14M16 11H22" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          </svg>
        </span>
        <span class="fo-sb-link-label">All Workers</span>
        <span class="fo-sb-badge" *ngIf="workersOnlineCount > 0">
          {{ workersOnlineCount }}
        </span>
      </a>

      <a routerLink="/invite-worker" routerLinkActive="fo-active" class="fo-sb-link" (click)="onNavClick()">
        <span class="fo-sb-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M16 21V19C16 16.8 14.2 15 12 15H5C2.8 15 1 16.8 1 19V21" stroke="currentColor" stroke-width="1.8"
              stroke-linecap="round" />
            <circle cx="8.5" cy="7" r="4" stroke="currentColor" stroke-width="1.8" />
            <line x1="20" y1="8" x2="20" y2="14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
            <line x1="17" y1="11" x2="23" y2="11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          </svg>
        </span>
        <span class="fo-sb-link-label">Invite Worker</span>
      </a>

      <!-- ── JOBS ─────────────────────────────────────── -->
      <div class="fo-sb-section">JOBS</div>

      <a routerLink="/jobs" routerLinkActive="fo-active" class="fo-sb-link" (click)="onNavClick()">
        <span class="fo-sb-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.8" />
            <path d="M16 7V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V7" stroke="currentColor" stroke-width="1.8"
              stroke-linecap="round" />
          </svg>
        </span>
        <span class="fo-sb-link-label">All Jobs</span>
      </a>

      <a routerLink="/create-job" routerLinkActive="fo-active" class="fo-sb-link fo-sb-link--create"
        (click)="onNavClick()">
        <span class="fo-sb-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8" />
            <line x1="12" y1="8" x2="12" y2="16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
            <line x1="8" y1="12" x2="16" y2="12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          </svg>
        </span>
        <span class="fo-sb-link-label">Create Job</span>
      </a>

      <!-- ── SAFETY & COMPLIANCE ──────────────────────── -->
      <div class="fo-sb-section">SAFETY & COMPLIANCE</div>

      <a routerLink="/safety" routerLinkActive="fo-active" class="fo-sb-link" (click)="onNavClick()">
        <span class="fo-sb-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M12 2L3 7V12C3 16.6 7 20.9 12 22C17 20.9 21 16.6 21 12V7L12 2Z" stroke="currentColor"
              stroke-width="1.8" stroke-linecap="round" />
          </svg>
        </span>
        <span class="fo-sb-link-label">Safety Command Center</span>
      </a>

      <a routerLink="/safety/permits" routerLinkActive="fo-active" class="fo-sb-link" (click)="onNavClick()">
        <span class="fo-sb-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
              stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
            <polyline points="14 2 14 8 20 8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span>
        <span class="fo-sb-link-label">Permits to Work</span>
      </a>

      <!-- ── REPORTS — Professional and above ─────────── -->
      <div class="fo-sb-section">REPORTS</div>

      <a [routerLink]="canAccessReports ? '/reports' : '/pricing'"
        [queryParams]="canAccessReports ? {} : { upgrade: 'true', feature: 'Reports' }" routerLinkActive="fo-active"
        class="fo-sb-link" [class.fo-sb-link--locked]="!canAccessReports" (click)="onNavClick()">
        <span class="fo-sb-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
              stroke="currentColor" stroke-width="1.8" />
            <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
            <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          </svg>
        </span>
        <span class="fo-sb-link-label">Reports</span>
        <span class="fo-sb-lock-icon" *ngIf="!canAccessReports">🔒</span>
      </a>

      <!-- ── INTELLIGENCE — Professional and above ─────── -->
      <div class="fo-sb-section">INTELLIGENCE</div>

      <a [routerLink]="canAccessAiInsights ? '/ai-insights' : '/pricing'"
        [queryParams]="canAccessAiInsights ? {} : { upgrade: 'true', feature: 'AI Insights' }"
        routerLinkActive="fo-active" class="fo-sb-link" [class.fo-sb-link--locked]="!canAccessAiInsights"
        (click)="onNavClick()">
        <span class="fo-sb-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8" />
            <path
              d="M12 6C9.8 6 8 7.8 8 10C8 11.5 8.8 12.8 10 13.5V15H14V13.5C15.2 12.8 16 11.5 16 10C16 7.8 14.2 6 12 6Z"
              stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
            <path d="M10 18H14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          </svg>
        </span>
        <span class="fo-sb-link-label">AI Insights</span>
        <span class="fo-sb-badge" *ngIf="canAccessAiInsights && aiUnreadCount > 0">
          {{ aiUnreadCount > 9 ? '9+' : aiUnreadCount }}
        </span>
        <span class="fo-sb-lock-icon" *ngIf="!canAccessAiInsights">🔒</span>
      </a>

      <!-- ── SETTINGS ──────────────────────────────────── -->
      <div class="fo-sb-section">SETTINGS</div>

      <a routerLink="/company-profile" routerLinkActive="fo-active" class="fo-sb-link" (click)="onNavClick()">
        <span class="fo-sb-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M19 21V19C19 17.9 18.1 17 17 17H7C5.9 17 5 17.9 5 19V21" stroke="currentColor" stroke-width="1.8"
              stroke-linecap="round" />
            <circle cx="12" cy="9" r="4" stroke="currentColor" stroke-width="1.8" />
          </svg>
        </span>
        <span class="fo-sb-link-label">Company Profile</span>
      </a>

      <a routerLink="/pricing" routerLinkActive="fo-active" class="fo-sb-link" (click)="onNavClick()">
        <span class="fo-sb-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
            <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
            <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          </svg>
        </span>
        <span class="fo-sb-link-label">Subscription</span>
      </a>
      <a routerLink="/contact" routerLinkActive="fo-active" class="fo-sb-link">
        <span class="fo-sb-icon">
          <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor">
            <path
              d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5z" />
          </svg>
        </span>
        <span class="fo-sb-link-label">Contact Support</span>
      </a>

    </nav>

    <!-- Footer -->
    <div class="fo-sb-footer">
      <div class="fo-sb-online-dot"></div>
      <span class="fo-sb-footer-text">System Online</span>
      <span class="fo-sb-footer-text" style="cursor: pointer;" routerLink="/privacy-policy">Privacy Policy</span>
    </div>

  </aside>

  <!-- ══════════════════════════════
       MAIN AREA
  ══════════════════════════════ -->
  <div class="fo-main">

    <!-- ✅ Subscription status banner — sits above topbar -->
    <app-subscription-status></app-subscription-status>

    <!-- Topbar -->
    <header class="fo-topbar">

      <div class="fo-topbar-left">
        <button class="fo-topbar-hamburger" (click)="toggleSidebar()" aria-label="Toggle menu">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            <line x1="3" y1="12" x2="21" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            <line x1="3" y1="18" x2="16" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
        <span class="fo-topbar-title">Admin Console</span>
      </div>

      <div class="fo-topbar-right">

        <!-- Bell / Notifications -->
        <div class="fo-notif-wrap">
          <button class="fo-topbar-bell" aria-label="Notifications" (click)="toggleNotifications($event)">
            <svg width="19" height="19" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 8C18 6.4 17.4 4.8 16.2 3.6C15 2.4 13.5 2 12 2C10.5 2 9 2.4 7.8 3.6C6.6 4.8 6 6.4 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
              <path
                d="M13.7 21C13.5 21.3 13.3 21.6 13 21.8C12.7 22 12.4 22 12 22C11.6 22 11.3 22 11 21.8C10.7 21.6 10.5 21.3 10.3 21"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
            </svg>
            <span class="fo-notif-dot" *ngIf="unreadCount > 0">
              {{ unreadCount > 9 ? '9+' : unreadCount }}
            </span>
          </button>

          <!-- Dropdown — stopPropagation so clicks inside don't close it -->
          <div class="fo-notif-dropdown" *ngIf="showDropdown" (click)="$event.stopPropagation()">

            <div class="fo-notif-header">
              <span class="fo-notif-title">Notifications</span>
              <button class="fo-notif-clear" (click)="clearNotifications()" *ngIf="notifications.length > 0">
                Clear all
              </button>
            </div>

            <div class="fo-notif-empty" *ngIf="notifications.length === 0">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path
                  d="M18 8C18 6.4 17.4 4.8 16.2 3.6C15 2.4 13.5 2 12 2C10.5 2 9 2.4 7.8 3.6C6.6 4.8 6 6.4 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                  stroke="currentColor" stroke-width="1.5" />
              </svg>
              <p>No notifications yet</p>
            </div>

            <div class="fo-notif-list" *ngIf="notifications.length > 0">
              <div class="fo-notif-item" *ngFor="let notif of notifications" [class.fo-notif-item--unread]="!notif.read"
                (click)="onNotificationClick(notif)">
                <span class="fo-notif-icon">{{ getNotifIcon(notif.type) }}</span>
                <div class="fo-notif-body">
                  <span class="fo-notif-item-title">{{ notif.title }}</span>
                  <span class="fo-notif-item-msg">{{ notif.message }}</span>
                  <span class="fo-notif-item-time">{{ getTimeAgo(notif.timestamp) }}</span>
                </div>
                <span class="fo-notif-unread-dot" *ngIf="!notif.read"></span>
              </div>
            </div>

          </div>
        </div>

        <div class="fo-topbar-divider"></div>

        <!-- User chip — navigates to company profile -->
        <a routerLink="/company-profile" class="fo-topbar-user" *ngIf="user">
          <div class="fo-user-avatar">
            {{ user.fullName?.charAt(0)?.toUpperCase() }}
          </div>
          <div class="fo-user-meta">
            <span class="fo-user-name">{{ user.fullName }}</span>
            <span class="fo-user-role">{{ user.companyName ?? 'Administrator' }}</span>
          </div>
        </a>

        <!-- Logout -->
        <button class="fo-topbar-logout" (click)="logout()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M9 21H5C4.5 21 4 20.8 3.6 20.4C3.2 20 3 19.5 3 19V5C3 4.5 3.2 4 3.6 3.6C4 3.2 4.5 3 5 3H9"
              stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
            <polyline points="16 17 21 12 16 7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
              stroke-linejoin="round" />
            <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          </svg>
          <span>Logout</span>
        </button>

      </div>
    </header>

    <!-- Routed page -->
    <main class="fo-content">
      <router-outlet></router-outlet>
    </main>

  </div>
</div>